var map = {
	"./char1.png": 242,
	"./char2.png": 8515,
	"./char3.png": 5700,
	"./char4.png": 2627,
	"./char5.png": 507,
	"./char6.png": 9552,
	"./char7.png": 5726,
	"./char8.png": 5715,
	"./charF.png": 8509,
	"./charM.png": 1681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5243;